/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Misfit_4Inputs */

const en_pc_alt_misfit_4 = /** @type {(inputs: Pc_Alt_Misfit_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending documents out for e-signature, signature tokens and long-term validation.`)
};

const zh_pc_alt_misfit_4 = /** @type {(inputs: Pc_Alt_Misfit_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发起电子签名流程、签名令牌以及长期验证。`)
};

/**
* | output |
* | --- |
* | "Sending documents out for e-signature, signature tokens and long-term validation." |
*
* @param {Pc_Alt_Misfit_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_misfit_4 = /** @type {((inputs?: Pc_Alt_Misfit_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Misfit_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_misfit_4(inputs)
	return zh_pc_alt_misfit_4(inputs)
});
export { pc_alt_misfit_4 as "pc.alt.misfit.4" }